export const EXPULSIONES_X_PAGINA = 30;
export const GOLES_X_PAGINA = 30;
export const PARTIDOS_X_PAGINA = 30;
export const TORNEOS_X_PAGINA = 15;
export const ITEM_COMBO_VACIO = '\u00A0';
